<main id="main-content" class="main-content" *ngIf="tableDataSource">
  <div style="display: flex;">
    <h1 id="baer-annual-comparison-heading">
      BAER Annual Comparison <span class="bar">|</span> <span
      class="title-date">Status as of {{ currentDate | date : 'MM/dd/yyyy' }}</span>
    </h1>
  </div>
  <div class="table-border-wide">
    <table
      mat-table [dataSource]="tableDataSource"
      aria-labelledby="baer-annual-comparison-heading baer-annual-comparison-caption"
    >
      <caption id="baer-annual-comparison-caption" class="usa-sr-only">
        BAER Annual Comparison
      </caption>
      <ng-container matColumnDef="region">
        <th mat-header-cell *matHeaderCellDef>Region</th>
        <td mat-cell *matCellDef="let data">{{ data.region }}</td>
      </ng-container>
      <ng-container matColumnDef="currentFires">
        <th mat-header-cell *matHeaderCellDef class="green">Fires</th>
        <td mat-cell *matCellDef="let data" class="green">{{ data.currentFires | number: '1.0-0' }}</td>
      </ng-container>
      <ng-container matColumnDef="currentAcres">
        <th mat-header-cell *matHeaderCellDef class="green">Acres</th>
        <td mat-cell *matCellDef="let data" class="green">{{ data.currentAcres | number: '1.0-0' }}</td>
      </ng-container>
      <ng-container matColumnDef="avg10Fires">
        <th mat-header-cell *matHeaderCellDef>Fires</th>
        <td mat-cell *matCellDef="let data">{{ data.avg10Fires | number: '1.0-0' }}</td>
      </ng-container>
      <ng-container matColumnDef="avg10Acres">
        <th mat-header-cell *matHeaderCellDef>Acres</th>
        <td mat-cell *matCellDef="let data">{{ data.avg10Acres | number: '1.0-0' }}</td>
      </ng-container>
      <ng-container matColumnDef="avg5Fires">
        <th mat-header-cell *matHeaderCellDef>Fires</th>
        <td mat-cell *matCellDef="let data">{{ data.avg5Fires | number: '1.0-0' }}</td>
      </ng-container>
      <ng-container matColumnDef="avg5Acres">
        <th mat-header-cell *matHeaderCellDef>Acres</th>
        <td mat-cell *matCellDef="let data">{{ data.avg5Acres | number: '1.0-0' }}</td>
      </ng-container>

      <!-- Header row region group -->
      <ng-container matColumnDef="header-row-region-group">
        <th mat-header-cell *matHeaderCellDef [attr.colspan]="1" class="main-header"></th>
      </ng-container>

      <!-- Header row current group -->
      <ng-container matColumnDef="header-row-current-group">
        <th mat-header-cell *matHeaderCellDef [attr.colspan]="2" [style.text-align]="'center'"
            class="green main-header">Current Year ({{ currentYear }})
        </th>
      </ng-container>

      <!-- Header row avg10 group -->
      <ng-container matColumnDef="header-row-avg10-group">
        <th mat-header-cell *matHeaderCellDef [attr.colspan]="2" [style.text-align]="'center'" class="main-header">
          10-year Average ({{ year10 }}-{{ currentYear - 1 }})
        </th>
      </ng-container>

      <!-- Header row avg5 group -->
      <ng-container matColumnDef="header-row-avg5-group">
        <th mat-header-cell *matHeaderCellDef [attr.colspan]="2" [style.text-align]="'center'" class="main-header">
          5-year Average ({{ year5 }}-{{ currentYear - 1 }})
        </th>
      </ng-container>

      <tr mat-header-row class=""
          *matHeaderRowDef="['header-row-region-group', 'header-row-current-group', 'header-row-avg10-group', 'header-row-avg5-group']">
      </tr>
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let element; columns: displayedColumns;"></tr>
    </table>
  </div>
  <div style="display: flex;">
    <h1 id="baer-biggest-regional-year-since-heading">
      BAER Biggest Regional Year Since {{ year10 }}
    </h1>
  </div>
  <div class="table-border-half">
    <table
      mat-table [dataSource]="tableDataSourceBiggest"
      aria-labelledby="baer-biggest-regional-year-since-caption baer-biggest-regional-year-since-heading"
    >
      <caption id="baer-biggest-regional-year-since-caption" class="usa-sr-only">
        BAER Biggest Regional Year Since {{ year10 }}
      </caption>
      <ng-container matColumnDef="region">
        <th mat-header-cell *matHeaderCellDef>Region</th>
        <td mat-cell *matCellDef="let data">{{ data.region }}</td>
      </ng-container>
      <ng-container matColumnDef="year">
        <th mat-header-cell *matHeaderCellDef>Year</th>
        <td mat-cell *matCellDef="let data">{{ data.year }}</td>
      </ng-container>
      <ng-container matColumnDef="fires">
        <th mat-header-cell *matHeaderCellDef>Fires</th>
        <td mat-cell *matCellDef="let data">{{ data.fires | number: '1.0-0' }}</td>
      </ng-container>
      <ng-container matColumnDef="acres">
        <th mat-header-cell *matHeaderCellDef>Acres</th>
        <td mat-cell *matCellDef="let data">{{ data.acres | number: '1.0-0' }}</td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumnsBiggest"></tr>
      <tr mat-row *matRowDef="let element; columns: displayedColumnsBiggest;"></tr>
    </table>
  </div>
</main>
